import EventEmitter from 'events'

import store from "@/store/store.js"

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also


class AuthService extends EventEmitter {

    async isAuthenticated() {
        let verify = false;
        if (window.sessionStorage.getItem('Ella-Auth-Token')) {
            verify = store.dispatch('auth/verifyJWT')
                .catch(() => {
                    return false
                })
        } else {
            return verify
        }
        return (verify);
    }

}
export default new AuthService();